<div class="paddedContent containerMargins" style="border: 1px solid #dddddd;">
	<div style="border-bottom: 1px solid var(--green-400);">
		<h3 style="text-align: center">Transaction Summary</h3>
	</div>

	<div style="border-bottom: 1px solid var(--green-400); padding:10px;">
		<div style="margin-bottom:8px;">01 Order Details</div>
		<div style="font-size: .9em;">
			{{ getTransactionTypeFriendlyName() }}
			<span [hidden]="orderDetails?.recurringSchedule?.period == undefined || orderDetails?.recurringSchedule?.periodCount == undefined">
				every {{ orderDetails?.recurringSchedule?.periodCount }}
				{{ orderDetails?.recurringSchedule?.period
				}}{{
				  orderDetails?.recurringSchedule &&
				  orderDetails.recurringSchedule.periodCount &&
				  orderDetails.recurringSchedule.periodCount > 1
					? 's'
					: ''
				}}
			  </span>
		</div>
		<div [hidden]="!orderDetails?.recurringSchedule || orderDetails?.transactionType != TransactionType.TRANSACTION_TYPE_RECUR" style="font-size: .9em;">

			<div [hidden]="orderDetails?.recurringSchedule?.firstChargeDate == undefined">
			  Starting on {{ orderDetails?.recurringSchedule?.firstChargeDate }}
			</div>
			<div [hidden]="orderDetails?.recurringSchedule?.chargeUntil == undefined">
			  Ending
			  <span [hidden]="orderDetails?.recurringSchedule?.chargeUntil != 'date'">
				on {{ orderDetails?.recurringSchedule?.finalChargeDate }}
			  </span>
			  <span [hidden]="orderDetails?.recurringSchedule?.chargeUntil != 'cancelled'">
				when it's cancelled
			  </span>
			  <span
				[hidden]="orderDetails?.recurringSchedule?.chargeUntil != 'number' || orderDetails?.recurringSchedule?.numberOfCharges == undefined">
				after {{ orderDetails?.recurringSchedule?.numberOfCharges }} payments
			  </span>
			</div>
		  </div>

	</div>

	<div style="border-bottom: 1px solid var(--green-400); padding:10px;">
		<div>02 Customer</div>
		<div style="margin-top:8px; font-size: .9em;" [hidden]="!selectedCustomer">
			<div>
				{{ selectedCustomer?.firstName }}
				{{ selectedCustomer?.lastName }}
			</div>
			<div style="overflow-x: hidden" [hidden]="!selectedCustomer || selectedCustomer.emailAddress == ''">
				{{ selectedCustomer?.emailAddress }}
			</div>
			<div [hidden]="!selectedCustomer || selectedCustomer.phone == ''">
				{{ formatPhone(selectedCustomer?.phone, selectedCustomer?.ccCode) }}
			</div>			
		</div>
	</div>

	<div style="border-bottom: 1px solid var(--green-400); padding:10px;">
		03 Payment
		<div style="margin-top:8px; font-size:.9em;" [hidden]="selectedPaymentMethod == undefined">
			{{ selectedPaymentMethod?.cardType }}&nbsp;&nbsp;
			{{ selectedPaymentMethod?.cardExpMonth }}/{{ selectedPaymentMethod?.cardExpYear }}<br/>
			{{ selectedPaymentMethod?.cardFirst6 }}******{{ selectedPaymentMethod?.cardLast4 }}
		</div>
	</div>

	<div style="border-bottom: 1px solid var(--green-400); padding:10px;">
		04 Shipping
		<div style="margin-top:8px; font-size:.9em;">
		</div>
	</div>

	<div style="text-align: right; padding-top:15px; margin-bottom: 15px;">
		Total: {{ getOrderTotalFormatted() }}
	</div>

	<div style="text-align: center;">
		<input type="button" class="primary" value="Submit" [disabled]="!readyToSubmit" (click)="onSubmit.emit()" />
	</div>

<!-- 	
	<div id="selectedTransTypeRow">
	  <div class="stackedInput" [hidden]="this.orderDetails.transactionType == undefined" style="border-top: 1px solid #dddddd; border-bottom: 1px solid #dddddd; padding: 10px 0px; margin-bottom: 10px;">
		<div style="font-size: 1.2em">
		  {{ getTransactionTypeFriendlyName() }}
		</div>

		<div class="stackedInput" [hidden]="this.recurringSchedule == undefined" style="padding-top: 10px; font-size: 1em">

		</div>
	  </div>

	  <div
		class="stackedInput"
		[hidden]="this.selectedCustomer == undefined"
		style="
		  border-top: 1px solid #dddddd;
		  border-bottom: 1px solid #dddddd;
		  padding: 10px 0px;
		  margin-bottom: 10px;
		"
	  >
		<div style="font-size: 1.2em">Customer</div>
		<div>
		  {{ selectedCustomer?.firstName }}
		  {{ selectedCustomer?.lastName }}
		</div>
		<div
		  style="overflow-x: hidden"
		  [hidden]="
			!selectedCustomer || selectedCustomer.emailAddress == ''
		  "
		>
		  {{ selectedCustomer?.emailAddress }}
		</div>
		<div [hidden]="!selectedCustomer || selectedCustomer.phone == ''">
		  {{ selectedCustomer?.phone }}
		</div>
	  </div>

	  <div
		class="stackedInput"
		[hidden]="this.selectedPaymentMethod == undefined"
		style="
		  border-top: 1px solid #dddddd;
		  border-bottom: 1px solid #dddddd;
		  padding: 10px 0px;
		  margin-bottom: 10px;
		"
	  >
		<div style="font-size: 1.2em; padding-bottom: 6px">
		  <span [hidden]="orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_AUTH && orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_CAPTURE">Bill to</span>
		  <span [hidden]="orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_REFUND">Refund to</span>
		</div>
		<div
		  [innerHTML]="getPaymentMethodName() | safeHtml: 'html'"
		></div>
	  </div>

	  <div
		class="stackedInput"
		[hidden]="
		  this.shippingAddress == undefined || this.shippingAddress.isEmpty
		"
		style="
		  border-top: 1px solid #dddddd;
		  border-bottom: 1px solid #dddddd;
		  padding: 10px 0px;
		  margin-bottom: 10px;
		"
	  >
		<div style="font-size: 1.2em">Ship to:</div>
		<div
		  [innerHTML]="
			shippingAddress?.formattedHTMLAddress | safeHtml: 'html'
		  "
		></div>
	  </div>

	  <div
		class="stackedInput"
		[hidden]="
		  this.amountToTransact == undefined || this.amountToTransact == 0
		"
		style="
		  border-top: 1px solid #dddddd;
		  border-bottom: 1px solid #dddddd;
		  padding: 10px 0px;
		  margin-bottom: 10px;
		  font-size: 1.3em;
		"
	  >
		Total: {{ this.amountToTransactFormatted }}
	  </div>

	  <div
		style="font-size: 0.9em"
		[hidden]="this.selectedPaymentMethod == undefined"
	  >
		<span
		  [hidden]="
			this.orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_AUTH
		  "
		  >This amount will be authorized but not charged</span
		>
		<span
		  [hidden]="
			this.orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_REFUND
		  "
		  >This amount will be refunded to the card listed above</span
		>
		<span
		  [hidden]="
			this.orderDetails.transactionType != TransactionType.TRANSACTION_TYPE_VOID
		  "
		  >This transaction will be voided</span
		>
	  </div>

	  <div class="" style="text-align: center">
		<input
		  type="button"
		  value="Submit {{ selectedTransactionFriendlyName }}"
		  class="button_primary button_var_2"
		  [disabled]="!formIsComplete || formIsBeingSubmitted"
		  (click)="btnCompleteTransaction_click()"
		  (keydown.enter)="btnCompleteTransaction_click()"
		/>
	  </div>
	</div> -->
  </div>